<template>
  <div>
    <v-expansion-panels v-if="!loading && specificFolder.length > 0">
      <DragDiv
        :list="specificFolder"
        group="second-sub-common-folder-items"
        ghost-class="ghost"
        animation="200"
        style="width: 100%"
        draggable=".my-list-common-second-sub-folder-items"
        @change="ChangeOrder"
      >
        <div class="my-folder-list" ref="subFolderList">
          <v-expansion-panel
            v-for="(item, i) in specificFolder"
            :key="i"
            :readonly="item.isDocument"
            class=".my-list-common-second-sub-folder-items"
          >
            <v-expansion-panel-header
              :hide-actions="item.isDocument"
              :style="`${item.isDocument ? 'cursor: default' : ''}`"
            >
              <div
                v-if="item.isDocument"
                class="d-flex justify-center"
                style="max-width: 20px; margin-top: -6px"
              >
                <v-checkbox
                  class="mr-1"
                  dense
                  small
                  v-model="item.selected"
                  hide-details
                  @click="addToDownloadList(item)"
                ></v-checkbox>
              </div>
              <span
                v-if="item.isDocument"
                style="margin-bottom: -4px; margin-left: 6px"
              >
                <v-icon class="pr-2" style="margin-top: -3px">
                  mdi-file-document-outline
                </v-icon>
                <span class="font-weight-medium pt-2">{{ item.name }}</span>
              </span>
              <span v-else>
                <v-icon class="pr-2" style="margin-top: -3px">
                  mdi-folder-outline
                </v-icon>
                <span class="font-weight-medium pt-2">{{ item.name }}</span>
              </span>
              <div
                :style="`display: flex; justify-content: flex-end; ${
                  item.isDocument ? 'margin-right: 32px' : 'margin-right: 12px'
                }`"
              >
                <span>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="ma-1"
                        small
                        depressed
                        color="primary"
                        v-if="user.mainType == 0"
                        @click.stop="
                          item.isDocument
                            ? editDocument(item)
                            : updateFolder(item)
                        "
                      >
                        <v-icon small color="#f5f5f5"
                          >mdi-pencil-outline</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>

                  <v-tooltip v-if="!item.isDocument" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="ma-1"
                        small
                        depressed
                        color="primary"
                        v-if="user.mainType == 0"
                        @click.stop="openAddDocModal(item)"
                      >
                        <v-icon small color="#f5f5f5"
                          >mdi-file-document-plus-outline</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Adicionar arquivo</span>
                  </v-tooltip>

                  <v-tooltip v-if="item.isDocument" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="ma-1"
                        small
                        depressed
                        color="primary"
                        @click.stop="getFile(item)"
                      >
                        <v-icon small color="#f5f5f5">mdi-open-in-new</v-icon>
                      </v-btn>
                    </template>
                    <span>Abrir documento</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="ma-1"
                        small
                        depressed
                        color="#ff4f64"
                        v-if="user.mainType == 0"
                        @click.stop="
                          item.isDocument
                            ? deleteDocument(item)
                            : deleteFolder(item)
                        "
                      >
                        <v-icon small color="#f5f5f5"
                          >mdi-trash-can-outline</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </span>
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <EquipmentManualThirdSubFolder
                v-if="!item.isDocument"
                :folder="item"
                @edit-document="editDocument"
                @update-folder="updateFolder"
                @move-folder="moveFolder"
                @get-file="getFile"
                @delete-document="deleteDocument"
                @delete-folder="deleteFolder"
                @add-to-download-list="addToDownloadList"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-card v-if="totalPages > 1" v-intersect="getMoreData"> </v-card>
        </div>
      </DragDiv>
    </v-expansion-panels>
    <div
      v-else-if="!loading && specificFolder.length === 0"
      class="text-center pa-4"
    >
      <span>Esta pasta está vazia</span>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import EquipmentManualThirdSubFolder from './equipmentManualThirdSubFolder.vue'

export default {
  name: 'commonSecondSubFolder',
  components: { EquipmentManualThirdSubFolder },
  props: {
    folder: Object,
  },
  data() {
    return {
      pageSize: 10,
      page: 1,
      sizes: [10, 30, 90, 180],
      totalItems: null,
      totalItensOnPage: 1,
      totalPages: null,
      apiService: new ApiService(),
      specificFolder: [],
      filterListFolderWithDoc: {
        page: 1,
        pageSize: 10,
      },
      loading: false,
      user: {},
    }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.getSpecificFolder(this.folder)
  },

  methods: {
    async reloadDataKeepingState() {
      const panel = this.panel
      this.getSpecificFolder(this.folder)
      this.panel = panel

      this.documentModal = false
      this.folderModal = false
    },

    async getMoreData(entries, observer, previous) {
      if (entries[0].isIntersecting) {
        this.filterListFolderWithDoc.page++

        if (this.filterListFolderWithDoc.page <= this.totalPages) {
          const initialHeight = this.$refs.subFolderList.scrollHeight
          this.filterListFolderWithDoc.folderId = this.folder.id

          try {
            const response = await this.apiService.get(
              `EquipmentManualDocumentFolder/list-with-doc`,
              this.filterListFolderWithDoc
            )
            this.specificFolder.push(...response.content.data)

            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.subFolderList.scrollTop = initialHeight
              }, 100)
            })
          } catch (error) {
            console.error('Erro ao carregar dados da pasta:', error)
          }
        }
      }
    },

    async ChangeOrder(event) {
      console.log(event)
      if (event.moved) {
        const findItem = event.moved.element
        findItem.order = event.moved.newIndex

        if (findItem.filePath) await this.updateDocOrder(findItem)
        else await this.updateFolderOrder(findItem)
      }
    },

    async updateDocOrder(item) {
      const model = {
        entityId: item.id,
        order: item.order,
      }
      this.apiService.post('EquipmentManualDocument/change-order', model)
    },

    async updateFolderOrder(item) {
      const model = {
        entityId: item.id,
        order: item.order,
      }
      this.apiService.post('EquipmentManualDocumentFolder/change-order', model)
    },

    async getSpecificFolder(folder) {
      this.filterListFolderWithDoc.folderId = folder.id
      this.loading = true

      try {
        const response = await this.apiService.get(
          `EquipmentManualDocumentFolder/list-with-doc`,
          this.filterListFolderWithDoc
        )
        this.specificFolder = response.content.data
        this.totalPages = response.content.pager.totalPages
        this.loading = false
      } catch (error) {
        this.loading = false
        console.error('Erro ao carregar dados da pasta:', error)
      }
    },

    editDocument(item) {
      this.$emit('edit-document', item)
    },

    updateFolder(item) {
      this.$emit('update-folder', item)
    },

    getFile(item) {
      this.$emit('get-file', item)
    },

    deleteDocument(item) {
      this.$emit('delete-document', item)
    },

    deleteFolder(item) {
      this.$emit('delete-folder', item)
    },

    addToDownloadList(item) {
      this.$emit('add-to-download-list', item)
    },

    openAddDocModal(item) {
      this.$emit('open-add-doc-modal', item)
    },
  },

  watch: {
    pageSize() {
      this.filterListFolderWithDoc.pageSize = this.pageSize
      this.filterListFolderWithDoc.page = 1
      this.getSpecificFolder(this.folder)
    },

    page() {
      this.filterListFolderWithDoc.page = this.page
      this.getSpecificFolder(this.folder)
    },
  },
}
</script>

<style scoped>
.my-folder-list {
  max-height: 400px;
  overflow-y: auto;
}

.my-folder-list::-webkit-scrollbar {
  background-color: #f9f9f9;
  width: 8px;
  border-radius: 20px;
}

.my-folder-list::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border-radius: 3.5px;
}
.topper-espansion-title {
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  overflow-wrap: break-word;
  text-align: center;
}
.v-expansion-panel-header {
  padding-block: 8px !important;
}
</style>
